import { render, staticRenderFns } from "./tacContractsRoodyMapper.vue?vue&type=template&id=dd71c2f6"
import script from "./tacContractsRoodyMapper.vue?vue&type=script&lang=js"
export * from "./tacContractsRoodyMapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports